"use strict";exports.arrayBufferToString=function(r){return String.fromCharCode.apply(null,new Uint8Array(r))};
//# sourceMappingURL=arrayBufferToString.cjs.map
